angular.module('bmsApp.accounting').controller('CreditInvoiceModalCtrl', function ($scope,
$modalInstance,
$ngBootbox,
invoice) {

	// console.info(invoice);

	$scope.ciModal = {
		instance: $modalInstance,
		invoice: invoice,
		cancel: function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		}
	};

	$scope.ciForm = {};

});
